import { X } from 'lucide-react';
import { useState } from 'react';
import { baseInputClass } from '../constants';
import { validateCoordinates } from '../utils';

interface ManualCoordinateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (lat: number, lng: number) => void;
}

export const ManualCoordinateModal = ({ isOpen, onClose, onAdd }: ManualCoordinateModalProps) => {
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleAdd = () => {
    const validation = validateCoordinates(lat, lng);
    if (!validation.valid) {
      setError(validation.error ?? 'Invalid coordinates');
      return;
    }

    onAdd(parseFloat(lat), parseFloat(lng));
    setLat('');
    setLng('');
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-4 w-full max-w-sm space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-[#621C43]">Add Coordinates Manually</h3>
          <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <X size={18} />
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-xs text-[#621C43] block mb-1">Latitude (-90 to 90)</label>
            <input
              type="number"
              step="any"
              value={lat}
              onChange={(e) => setLat(e.target.value)}
              placeholder="e.g., 40.7128"
              className={baseInputClass}
            />
          </div>
          <div>
            <label className="text-xs text-[#621C43] block mb-1">Longitude (-180 to 180)</label>
            <input
              type="number"
              step="any"
              value={lng}
              onChange={(e) => setLng(e.target.value)}
              placeholder="e.g., -74.006"
              className={baseInputClass}
            />
          </div>
        </div>

        {error && <p className="text-xs text-red-500">{error}</p>}

        <div className="flex gap-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-3 py-2 border border-[#C0275E] text-[#621C43] rounded-lg text-sm hover:bg-pink-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleAdd}
            className="flex-1 px-3 py-2 bg-[#C0275E] text-white rounded-lg text-sm hover:bg-[#a01f4e]"
          >
            Add Point
          </button>
        </div>
      </div>
    </div>
  );
};
